module.exports = "<li>\n  <span class=\"fa-li\"><i class=\"far fa-file-alt\"></i></span>\n  {{ $ctrl.file.filename }}\n</li>"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/profile/component/file.html
// module id = 1180
// module chunks = 0